// Счётчик непрочитанных поверх иконки: 1–99, больше — «99+»; при нуле не показывается
import React from 'react';
import { Badge } from '@mui/material';

const ACCENT = '#ff7043';

export default function UnreadBadge({ count, children, badgeSx }) {
  return (
    <Badge
      badgeContent={count}
      max={99}
      invisible={!count}
      overlap="circular"
      sx={{
        '& .MuiBadge-badge': {
          minWidth: 18,
          height: 18,
          px: '5px',
          fontSize: '11px',
          fontWeight: 700,
          backgroundColor: ACCENT,
          color: '#1a0f0a',
          fontVariantNumeric: 'tabular-nums',
          ...badgeSx,
        },
      }}
    >
      {children}
    </Badge>
  );
}

export function unreadLabel(count) {
  return count ? `Уведомления, непрочитанных: ${count}` : 'Уведомления';
}
